// Import our custom CSS
import '../scss/main.scss';

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Import other scripts and files
import initLavaBar from "./components/lava-line";
import initFixedHeaderOnScroll from "./components/fixed-header";
import initVwVariable from "./components/dynamic-vw";
import "./cookieconsent/cookieconsent";
import "./cookieconsent/cookieconsent-init";
import "./hrk_search/main";

// Run our scripts
initLavaBar();
initFixedHeaderOnScroll();
initVwVariable();
